var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dating-sincerity"},[_c('StackRouterHeaderBar'),_c('main',{staticClass:"main"},[_c('FeedbackTop',{staticClass:"m-b-40",attrs:{"title":`${
                _vm.user.name || _vm.user.profile.nickname
            }님은<br /><span class='c-primary f-bold'>진정성 있는</span> 분이었나요?`}}),_c('FeedbackOptionItems',{on:{"select":_vm.onSelectItems},model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }